import React, { useState, useEffect } from 'react';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);

      const sections = ['services', 'portfolio', 'gallery', 'about', 'contact'];
      const scrollPosition = window.scrollY + 120;

      for (const sectionId of sections) {
        const el = document.getElementById(sectionId);
        if (el) {
          const top = el.offsetTop;
          const height = el.offsetHeight;
          if (scrollPosition >= top && scrollPosition < top + height) {
            setActiveSection(sectionId);
            return;
          }
        }
      }
      if (window.scrollY < 200) {
        setActiveSection('home');
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const navLinks = [
    { href: '#services', id: 'services', label: 'Services' },
    { href: '#portfolio', id: 'portfolio', label: 'Portfolio' },
    { href: '#about', id: 'about', label: 'About' },
    { href: '#gallery', id: 'gallery', label: 'Gallery' },
    { href: '#contact', id: 'contact', label: 'Contact' },
  ];

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header
      className={`header ${scrolled ? 'header--scrolled' : ''}`}
      role="banner"
    >
      <div className="header__blur-backdrop" aria-hidden="true" />
      
      <nav className="nav container" role="navigation" aria-label="Main navigation">
        {/* Brand Logo with Orange Glow Halo */}
        <a href="/" className="nav__brand" aria-label="Shamoka Photography Home">
          
         
        </a>

        {/* Desktop Navigation Links */}
        <ul className="nav__menu-desktop" role="menubar">
          {navLinks.map((link) => (
            <li key={link.href} role="none">
              <a
                href={link.href}
                className={`nav__link ${activeSection === link.id ? 'nav__link--active' : ''}`}
                role="menuitem"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Action Controls */}
        <div className="nav__actions">
          <a href="#contact" className="btn btn--header-cta">
            <span className="btn__flare" aria-hidden="true" />
            <span>Book Session</span>
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </a>

          {/* Mobile Hamburger Button */}
          <button
            className={`nav__toggle ${menuOpen ? 'nav__toggle--open' : ''}`}
            onClick={toggleMenu}
            aria-expanded={menuOpen}
            aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
          >
            <span className="nav__toggle-bar" />
            <span className="nav__toggle-bar" />
            <span className="nav__toggle-bar" />
          </button>
        </div>
      </nav>

      {/* Mobile Drawer Overlay */}
      <div className={`nav__mobile-drawer ${menuOpen ? 'nav__mobile-drawer--open' : ''}`}>
        <div className="nav__mobile-inner">
          <ul className="nav__mobile-list">
            {navLinks.map((link, idx) => (
              <li
                key={link.href}
                className="nav__mobile-item"
                style={{ transitionDelay: `${idx * 0.05 + 0.1}s` }}
              >
                <a
                  href={link.href}
                  className={`nav__mobile-link ${activeSection === link.id ? 'nav__mobile-link--active' : ''}`}
                  onClick={closeMenu}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="nav__mobile-footer">
            <a
              href="#contact"
              className="btn btn--primary btn--full"
              onClick={closeMenu}
            >
              Book a Session
            </a>
            <p className="nav__mobile-status">
              <span className="nav__status-pulse" /> Taking bookings for upcoming dates
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;